import { render, staticRenderFns } from "./SensorDetailDialog.vue?vue&type=template&id=5876470a&scoped=true&"
import script from "./SensorDetailDialog.vue?vue&type=script&lang=js&"
export * from "./SensorDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./SensorDetailDialog.vue?vue&type=style&index=0&id=5876470a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876470a",
  null
  
)

export default component.exports